module.exports = __webpack_public_path__ + "images/for_companies_lp/top_pc_b893f7ea46df8454b80d6fbf62c69f81.jpg";